import {
  init_logDepthVertex
} from "./chunk-R5EZNSDL.mjs";
import {
  init_instancesDeclaration
} from "./chunk-S2QACKYP.mjs";
import {
  init_bakedVertexAnimation,
  init_bakedVertexAnimationDeclaration
} from "./chunk-BVXC3PX6.mjs";
import {
  init_instancesVertex
} from "./chunk-QTN4RCMJ.mjs";
import {
  init_logDepthDeclaration
} from "./chunk-AXOJYKSZ.mjs";
import {
  init_morphTargetsVertexGlobal
} from "./chunk-MEKU3TPB.mjs";
import {
  init_morphTargetsVertex
} from "./chunk-V2P25H6U.mjs";
import {
  init_bonesVertex
} from "./chunk-RNSXW2BB.mjs";
import {
  init_clipPlaneVertex
} from "./chunk-6WC7OF4Z.mjs";
import {
  init_bonesDeclaration
} from "./chunk-F3QSZLQN.mjs";
import {
  init_clipPlaneVertexDeclaration
} from "./chunk-STSH6UFH.mjs";
import {
  init_morphTargetsVertexGlobalDeclaration
} from "./chunk-XGY57BJN.mjs";
import {
  init_morphTargetsVertexDeclaration
} from "./chunk-PSHQNVKK.mjs";
import {
  ShaderStore,
  init_shaderStore
} from "./chunk-74QERPGX.mjs";
import {
  __esm
} from "./chunk-AU4RG7EN.mjs";

// node_modules/@babylonjs/core/ShadersWGSL/outline.vertex.js
var name, shader, outlineVertexShaderWGSL;
var init_outline_vertex = __esm({
  "node_modules/@babylonjs/core/ShadersWGSL/outline.vertex.js"() {
    init_shaderStore();
    init_bonesDeclaration();
    init_bakedVertexAnimationDeclaration();
    init_morphTargetsVertexGlobalDeclaration();
    init_morphTargetsVertexDeclaration();
    init_clipPlaneVertexDeclaration();
    init_instancesDeclaration();
    init_logDepthDeclaration();
    init_morphTargetsVertexGlobal();
    init_morphTargetsVertex();
    init_instancesVertex();
    init_bonesVertex();
    init_bakedVertexAnimation();
    init_clipPlaneVertex();
    init_logDepthVertex();
    name = "outlineVertexShader";
    shader = `attribute position: vec3f;attribute normal: vec3f;
#include<bonesDeclaration>
#include<bakedVertexAnimationDeclaration>
#include<morphTargetsVertexGlobalDeclaration>
#include<morphTargetsVertexDeclaration>[0..maxSimultaneousMorphTargets]
#include<clipPlaneVertexDeclaration>
uniform offset: f32;
#include<instancesDeclaration>
uniform viewProjection: mat4x4f;
#ifdef ALPHATEST
varying vUV: vec2f;uniform diffuseMatrix: mat4x4f; 
#ifdef UV1
attribute uv: vec2f;
#endif
#ifdef UV2
attribute uv2: vec2f;
#endif
#endif
#include<logDepthDeclaration>
#define CUSTOM_VERTEX_DEFINITIONS
@vertex
fn main(input: VertexInputs)->FragmentInputs {var positionUpdated: vec3f=vertexInputs.position;var normalUpdated: vec3f=vertexInputs.normal;
#ifdef UV1
var uvUpdated: vec2f=vertexInputs.uv;
#endif
#include<morphTargetsVertexGlobal>
#include<morphTargetsVertex>[0..maxSimultaneousMorphTargets]
var offsetPosition: vec3f=positionUpdated+(normalUpdated*uniforms.offset);
#include<instancesVertex>
#include<bonesVertex>
#include<bakedVertexAnimation>
var worldPos: vec4f=finalWorld*vec4f(offsetPosition,1.0);vertexOutputs.position=uniforms.viewProjection*worldPos;
#ifdef ALPHATEST
#ifdef UV1
vertexOutputs.vUV=(uniforms.diffuseMatrix*vec4f(uvUpdated,1.0,0.0)).xy;
#endif
#ifdef UV2
vertexOutputs.vUV=(uniforms.diffuseMatrix*vec4f(vertexInputs.uv2,1.0,0.0)).xy;
#endif
#endif
#include<clipPlaneVertex>
#include<logDepthVertex>
}
`;
    ShaderStore.ShadersStoreWGSL[name] = shader;
    outlineVertexShaderWGSL = { name, shader };
  }
});

export {
  outlineVertexShaderWGSL,
  init_outline_vertex
};
